import { MapModalData } from './map-redirect-modal.component';

export const ROUTER_NAVIGATE = 'ROUTER_NAVIGATE';
export const MAPBOX_JUMP_TO = 'MAPBOX_JUMP_TO';

export const dataIsNotAvailableForLevelText: MapModalData = {
  headerText: 'Data is not available at the selected level',
  subHeaderText: 'The map will be displayed in gray',
  disableClose: false,
  hasBackdrop: true,
};

export const signIn: MapModalData = {
  headerText: 'Sign in',
  mainText: 'Please sign in again',
  buttonText: 'To sign in',
  URLtoGo: '/sign-in',
  actionType: ROUTER_NAVIGATE,
  disableClose: false,
  hasBackdrop: true,
};
